module.exports = __webpack_public_path__ + "img/img_works17.eb65ec24.jpg";